import isArray from 'lodash/isArray';
import pluralize from 'pluralize';
import ArrayType from './Array';

export default {
  ...ArrayType,
  dumpTo(key) {
    return `${pluralize.singular(key)}Ids`;
  },
  dump(values) {
    if (!isArray(values)) return this.default();
    return values.map(value => value.id);
  },
  mapToDefault(values) {
    return !values;
  },
};



// WEBPACK FOOTER //
// ./mixins/Form/Types/ReferenceList.js